import React  from 'react';
import Villa from './Villa';
import {
    BrowserRouter,
    Switch,
    Route,
    withRouter
} from "react-router-dom";

class Routing extends React.Component {
    // eslint-disable-next-line no-useless-constructor
    constructor(props){
            super(props);
            let location = window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
            this.state={
                location:location
            }
             
    }

    render(){
          return(
           <React.Fragment>
                <BrowserRouter basename="/villa/">
                    <Route exact path={"/"+this.state.location} villa={this.villa} component={withRouter(Villa)} /> 
                    <Route exact path={"/why-us/"+this.state.location} villa={this.villa} component={withRouter(Villa)} /> 
                    <Route exact path={"/concierge/"+this.state.location} villa={this.villa} component={withRouter(Villa)} /> 
                    <Route exact path={"/destination/"+this.state.location} villa={this.villa} component={withRouter(Villa)} /> 
                    <Route exact path={"/talk-to-us/"+this.state.location} villa={this.villa} component={withRouter(Villa)} /> 
                    {/* <Route exact path={"/"+this.state.location} villa={this.villa} component={withRouter(Villa)} />  */}
                </BrowserRouter>
           </React.Fragment>
          );
    }
}

export default Routing;